// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UAMachineryLifetimeVariable } from './UAMachineryLifetimeVariable';
import {
    UAMachineryLifetimeVariableFromJSON,
    UAMachineryLifetimeVariableFromJSONTyped,
    UAMachineryLifetimeVariableToJSON,
    UAMachineryLifetimeVariableToJSONTyped,
} from './UAMachineryLifetimeVariable';
import type { UAAlarmCondition } from './UAAlarmCondition';
import {
    UAAlarmConditionFromJSON,
    UAAlarmConditionFromJSONTyped,
    UAAlarmConditionToJSON,
    UAAlarmConditionToJSONTyped,
} from './UAAlarmCondition';
import type { UAFunctionFunctionSetInner } from './UAFunctionFunctionSetInner';
import {
    UAFunctionFunctionSetInnerFromJSON,
    UAFunctionFunctionSetInnerFromJSONTyped,
    UAFunctionFunctionSetInnerToJSON,
    UAFunctionFunctionSetInnerToJSONTyped,
} from './UAFunctionFunctionSetInner';
import type { UALADSComponent } from './UALADSComponent';
import {
    UALADSComponentFromJSON,
    UALADSComponentFromJSONTyped,
    UALADSComponentToJSON,
    UALADSComponentToJSONTyped,
} from './UALADSComponent';
import type { UAMachineryOperationCounter } from './UAMachineryOperationCounter';
import {
    UAMachineryOperationCounterFromJSON,
    UAMachineryOperationCounterFromJSONTyped,
    UAMachineryOperationCounterToJSON,
    UAMachineryOperationCounterToJSONTyped,
} from './UAMachineryOperationCounter';
import type { LADSDeviceStateMachine } from './LADSDeviceStateMachine';
import {
    LADSDeviceStateMachineFromJSON,
    LADSDeviceStateMachineFromJSONTyped,
    LADSDeviceStateMachineToJSON,
    LADSDeviceStateMachineToJSONTyped,
} from './LADSDeviceStateMachine';
import type { MachineryItemState } from './MachineryItemState';
import {
    MachineryItemStateFromJSON,
    MachineryItemStateFromJSONTyped,
    MachineryItemStateToJSON,
    MachineryItemStateToJSONTyped,
} from './MachineryItemState';
import type { UADIDeviceHealthEnumeration } from './UADIDeviceHealthEnumeration';
import {
    UADIDeviceHealthEnumerationFromJSON,
    UADIDeviceHealthEnumerationFromJSONTyped,
    UADIDeviceHealthEnumerationToJSON,
    UADIDeviceHealthEnumerationToJSONTyped,
} from './UADIDeviceHealthEnumeration';
import type { UALADSComponentIdentification } from './UALADSComponentIdentification';
import {
    UALADSComponentIdentificationFromJSON,
    UALADSComponentIdentificationFromJSONTyped,
    UALADSComponentIdentificationToJSON,
    UALADSComponentIdentificationToJSONTyped,
} from './UALADSComponentIdentification';
import type { UALADSFunctionalUnit } from './UALADSFunctionalUnit';
import {
    UALADSFunctionalUnitFromJSON,
    UALADSFunctionalUnitFromJSONTyped,
    UALADSFunctionalUnitToJSON,
    UALADSFunctionalUnitToJSONTyped,
} from './UALADSFunctionalUnit';

/**
 * 
 * @export
 * @interface UALADSDevice
 */
export interface UALADSDevice {
    /**
     * 
     */
    browseName: string;
    /**
     * 
     */
    displayName: string;
    /**
     * AssetId is a user writable alphanumeric character sequence uniquely identifying a component. The ID is provided by the integrator or user of thedevice.
     */
    assetId?: string;
    /**
     * ComponentName is a user writable name provided by the integrator or user of the component.
     */
    componentName?: string;
    /**
     * HierarchicalLocation provides the hierarchical
     * location of the LADS Device. The structure inside
     * the string may expose several levels. How this is
     * exposed, which delimiters are used, etc. is
     * vendor-specific. Examples of such strings are
     * “FactoryA/BuildingC/Floor1” or
     * “Area1-ProcessCell17-Unit4” (see OPC UA OPC
     * 10000-110 for more Details).
     */
    hierarchicalLocation?: string;
    /**
     * OperationalLocation provides the operational
     * location of the Device or Component. The
     * structure within the string may expose several
     * levels. How this is exposed, which delimiters are
     * used, etc. is vendor-specific. Examples of such
     * strings are “Warehouse1/Sheet3” or
     * “StainlessSteelTote3” (see OPC UA OPC 10000-110
     * for more details).
     */
    operationalLocation?: string;
    /**
     * 
     */
    identification: UALADSComponentIdentification;
    /**
     * 
     */
    deviceHealth?: UADIDeviceHealthEnumeration;
    /**
     * 
     */
    deviceHealthAlarms?: Array<UAAlarmCondition>;
    /**
     * 
     */
    lifetimeCounters?: Array<UAMachineryLifetimeVariable>;
    /**
     * 
     */
    operationCounters?: Array<UAMachineryOperationCounter>;
    /**
     * 
     */
    maintenance?: Array<object>;
    /**
     * 
     */
    components?: Array<UALADSComponent>;
    /**
     * 
     */
    deviceState: LADSDeviceStateMachine;
    /**
     * 
     */
    machineryItemState?: MachineryItemState;
    /**
     * maintenance
     *   MachineryItem is set into maintenance mode with
     *   the intention to carry out maintenance or
     *   servicing activities
     * none
     *   There is currently no operation mode available
     * processing
     *   MachineryItem is set into processing mode with
     *   the intention to carry out the value adding
     *   activities
     * 
     * 
     *      setup:
     *        MachineryItem is set into setup mode with the
     *        intention to carry out setup, preparation or
     *        postprocessing activities of a production process
     * 
     */
    readonly machineryOperationMode?: UALADSDeviceMachineryOperationModeEnum;
    /**
     * 
     */
    functionalUnitSet?: Array<UALADSFunctionalUnit>;
    /**
     * Functions organized directly below the device's FunctionSet. Used by monitored (modelled) devices, where single functions of other devices are mounted at device level instead of inside a FunctionalUnit. `browsePath` is the canonical source path of each function. Empty/absent for regular devices.
     */
    functionSet?: Array<UAFunctionFunctionSetInner>;
    /**
     * Download links to the device's DeviceTypeImage files (DI spec), one per image variable: `lads/binary/{nodeId}`. Empty/absent when the device exposes no DeviceTypeImage folder.
     */
    readonly deviceTypeImage?: Array<string>;
}


/**
 * @export
 */
export const UALADSDeviceMachineryOperationModeEnum = {
    Maintenance: 'maintenance',
    None: 'none',
    Processing: 'processing',
    Setup: 'setup'
} as const;
export type UALADSDeviceMachineryOperationModeEnum = typeof UALADSDeviceMachineryOperationModeEnum[keyof typeof UALADSDeviceMachineryOperationModeEnum];


/**
 * Check if a given object implements the UALADSDevice interface.
 */
export function instanceOfUALADSDevice(value: object): value is UALADSDevice {
    if (!('browseName' in value) || value['browseName'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    if (!('identification' in value) || value['identification'] === undefined) return false;
    if (!('deviceState' in value) || value['deviceState'] === undefined) return false;
    return true;
}

export function UALADSDeviceFromJSON(json: any): UALADSDevice {
    return UALADSDeviceFromJSONTyped(json, false);
}

export function UALADSDeviceFromJSONTyped(json: any, ignoreDiscriminator: boolean): UALADSDevice {
    if (json == null) {
        return json;
    }
    return {
        
        'browseName': json['browseName'],
        'displayName': json['displayName'],
        'assetId': json['assetId'] == null ? undefined : json['assetId'],
        'componentName': json['componentName'] == null ? undefined : json['componentName'],
        'hierarchicalLocation': json['hierarchicalLocation'] == null ? undefined : json['hierarchicalLocation'],
        'operationalLocation': json['operationalLocation'] == null ? undefined : json['operationalLocation'],
        'identification': UALADSComponentIdentificationFromJSON(json['identification']),
        'deviceHealth': json['deviceHealth'] == null ? undefined : UADIDeviceHealthEnumerationFromJSON(json['deviceHealth']),
        'deviceHealthAlarms': json['deviceHealthAlarms'] == null ? undefined : ((json['deviceHealthAlarms'] as Array<any>).map(UAAlarmConditionFromJSON)),
        'lifetimeCounters': json['lifetimeCounters'] == null ? undefined : ((json['lifetimeCounters'] as Array<any>).map(UAMachineryLifetimeVariableFromJSON)),
        'operationCounters': json['operationCounters'] == null ? undefined : ((json['operationCounters'] as Array<any>).map(UAMachineryOperationCounterFromJSON)),
        'maintenance': json['maintenance'] == null ? undefined : json['maintenance'],
        'components': json['components'] == null ? undefined : ((json['components'] as Array<any>).map(UALADSComponentFromJSON)),
        'deviceState': LADSDeviceStateMachineFromJSON(json['deviceState']),
        'machineryItemState': json['machineryItemState'] == null ? undefined : MachineryItemStateFromJSON(json['machineryItemState']),
        'machineryOperationMode': json['machineryOperationMode'] == null ? undefined : json['machineryOperationMode'],
        'functionalUnitSet': json['functionalUnitSet'] == null ? undefined : ((json['functionalUnitSet'] as Array<any>).map(UALADSFunctionalUnitFromJSON)),
        'functionSet': json['functionSet'] == null ? undefined : ((json['functionSet'] as Array<any>).map(UAFunctionFunctionSetInnerFromJSON)),
        'deviceTypeImage': json['deviceTypeImage'] == null ? undefined : json['deviceTypeImage'],
    };
}

export function UALADSDeviceToJSON(json: any): UALADSDevice {
    return UALADSDeviceToJSONTyped(json, false);
}

export function UALADSDeviceToJSONTyped(value?: Omit<UALADSDevice, 'machineryOperationMode'|'deviceTypeImage'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'browseName': value['browseName'],
        'displayName': value['displayName'],
        'assetId': value['assetId'],
        'componentName': value['componentName'],
        'hierarchicalLocation': value['hierarchicalLocation'],
        'operationalLocation': value['operationalLocation'],
        'identification': UALADSComponentIdentificationToJSON(value['identification']),
        'deviceHealth': UADIDeviceHealthEnumerationToJSON(value['deviceHealth']),
        'deviceHealthAlarms': value['deviceHealthAlarms'] == null ? undefined : ((value['deviceHealthAlarms'] as Array<any>).map(UAAlarmConditionToJSON)),
        'lifetimeCounters': value['lifetimeCounters'] == null ? undefined : ((value['lifetimeCounters'] as Array<any>).map(UAMachineryLifetimeVariableToJSON)),
        'operationCounters': value['operationCounters'] == null ? undefined : ((value['operationCounters'] as Array<any>).map(UAMachineryOperationCounterToJSON)),
        'maintenance': value['maintenance'],
        'components': value['components'] == null ? undefined : ((value['components'] as Array<any>).map(UALADSComponentToJSON)),
        'deviceState': LADSDeviceStateMachineToJSON(value['deviceState']),
        'machineryItemState': MachineryItemStateToJSON(value['machineryItemState']),
        'functionalUnitSet': value['functionalUnitSet'] == null ? undefined : ((value['functionalUnitSet'] as Array<any>).map(UALADSFunctionalUnitToJSON)),
        'functionSet': value['functionSet'] == null ? undefined : ((value['functionSet'] as Array<any>).map(UAFunctionFunctionSetInnerToJSON)),
    };
}

